import { UploadButton } from "../Button"
import { FormRow, Label, Input } from "../Form"

import "./styles.scss"

export const LinkOrUpload = ({
  labelInput,
  hasValue,
  register,
  required,
  name,
  errors,
  placeholderInput,
  labelButton,
  handleFileChange,
  acceptFile,
  nameFile
}) => {
  return (
    <>
      <FormRow>
        <Label label={labelInput} forInput={name}/>
        <Input
          placeholder={placeholderInput}
          register={register(name, required)}
          hasError={errors}
          hasValue={hasValue}
        />
      </FormRow>
      <div>
        <UploadButton
          color="tertiary-orange"
          label={`ou ${labelButton}`}
          onFileChange={handleFileChange}
          accept={acceptFile}
          name={nameFile}
        />
      </div>
      </>
  )
}


export const UploadFile = ({
  labelButton,
  handleFileChange,
  acceptFile,
  nameFile,
  color
}) => {
  return (
    <>
      <UploadButton
          color={color || "orange"}
          label={`${labelButton}`}
          onFileChange={handleFileChange}
          accept={acceptFile}
          variant={"outline"}
          name={nameFile}
        />
      </>
  )
}
